import React from "react";
import { Table, Tooltip, Button, Row, Col, Modal } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

export default class ScheduleListView extends React.Component {
  render() {
    const {
      doctorsDetail,
      toggleScheduleRemoveModal,
      handleEdit,
      showScheduleRemoveModal,
      closeModal,
      handleDeletion,
      isProcessing,
      scheduleType
    } = this.props;
    const timingsObj =
      scheduleType && scheduleType === "regular"
        ? doctorsDetail.schedules
        : doctorsDetail.discount_schedule;

    let scheduleColumns = null;
    const timingColumns = [
      {
        title: "Days",
        dataIndex: "days",
        key: "days",
        align: "left",
        render: record => {
          return <div>{record.length < 7 ? record.join(", ") : "Daily"}</div>;
        }
      },
      {
        title: "Timings",
        key: "schedules",
        align: "left",
        render: (record, text) => {
          return (
            <div>
              {moment(record.start_time).format("hh:mm a")} -{" "}
              {moment(record.end_time).format("hh:mm a")}
            </div>
          );
        }
      },

      {
        title: "",
        dataIndex: "action",
        key: "action",
        render: (text, record) => (
          <span>
            <Tooltip title="Edit">
              <a
                href="javascript:;"
                className="icon-link edit-icon-btn action"
                onClick={() => {
                  handleEdit(record);
                }}
              >
                {""}
              </a>
            </Tooltip>

            <Tooltip title="Delete">
              <a
                href="javascript:;"
                onClick={() => toggleScheduleRemoveModal(record.id)}
                className="delete-link"
              />
            </Tooltip>
          </span>
        )
      }
    ];

    const discountedColumns = [
      {
        title: "Days",
        dataIndex: "days",
        key: "days",
        align: "left",
        render: record => {
          return <div>{record.length < 7 ? record.join(", ") : "Daily"}</div>;
        }
      },
      {
        title: "Timings",
        key: "schedules",
        align: "left",
        render: (record, text) => {
          return (
            <div>
              {moment(record.start_time).format("hh:mm a")} -{" "}
              {moment(record.end_time).format("hh:mm a")}
            </div>
          );
        }
      },
      {
        title: "Fees",
        key: "discounted_fees",
        align: "left",
        render: (record, text) => {
          return <div>{record.discounted_fees}</div>;
        }
      },
      {
        title: "",
        dataIndex: "action",
        key: "action",
        render: (text, record) => (
          <span>
            <Tooltip title="Edit">
              <a
                href="javascript:;"
                className="edit-link"
                onClick={() => {
                  handleEdit(record);
                }}
              >
                {""}
              </a>
            </Tooltip>

            <Tooltip title="Delete">
              <a
                href="javascript:;"
                onClick={() => toggleScheduleRemoveModal(record.id)}
                className="delete-link"
              />
            </Tooltip>
          </span>
        )
      }
    ];

    if (scheduleType === "regular") {
      scheduleColumns = timingColumns;
    } else {
      scheduleColumns = discountedColumns;
    }

    return (
      <div className="detail-panel backgroundWhite ">
        <div className="light-bg round-5x p-15 eq-column">
          {timingsObj.length > 0 ? (
            <Table
              dataSource={timingsObj}
              pagination={false}
              columns={scheduleColumns}
              className="kc-table"
              rowKey="id"
            />
          ) : (
            "No timings are available for the doctor"
          )}

          <Modal
            title={null}
            visible={showScheduleRemoveModal}
            footer={null}
            className="kc-modal-medium no-footer text-type-modal"
            onCancel={closeModal}
          >
            <div className="website-modal-wrapper text-center">
              <div className="heading">Delete Schedule</div>
              <div className="description">
                {"Are you sure you want to delete schedule?"}
              </div>
              <div className="text-center mt-10">
                <Button
                  type="primary"
                  size="small"
                  onClick={handleDeletion}
                  loading={isProcessing}
                  className="text-type-modal-btn"
                >
                  {"Delete"}
                </Button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}
